import { useEffect, useState } from 'react'

// Subscribes to a CSS media query (e.g. '(min-width: 1440px)') and returns whether it
// matches. Exists because useBreakpoint only resolves $grid-breakpoints tokens
// (sm/md/lg/xl/xxl = 640/960/1280/1600/1920) and cannot express design cuts that fall
// between them — e.g. 1440px, which the SCSS also hardcodes as
// $main-filters-slot-wide-min. Prefer useBreakpoint when the cut IS a token.
// Returns false on SSR and first paint; guarded for jsdom, which lacks matchMedia.
function useMediaQuery(query) {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined

    const mediaQuery = window.matchMedia(query)
    const update = () => setMatches(mediaQuery.matches)
    update()
    mediaQuery.addEventListener('change', update)
    return () => mediaQuery.removeEventListener('change', update)
  }, [query])

  return matches
}

export default useMediaQuery
